import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'react-bootstrap';
import classname from 'classnames';
import logPropError from '../../utils/logPropError';
var errorProps = [{
  prop: 'labelsClassName',
  replacement: 'labels.labelClassName'
}];
var SteppedProgressBar = function SteppedProgressBar(props) {
  var className = props.className,
    variant = props.variant,
    labels = props.labels,
    mobileBreakpoint = props.mobileBreakpoint,
    selectedStepNumber = props.selectedStepNumber,
    disableFollowingPageIndex = props.disableFollowingPages,
    onSelectedChanged = props.onSelectedChanged;
  var _useState = useState(disableFollowingPageIndex ? disableFollowingPageIndex : selectedStepNumber),
    _useState2 = _slicedToArray(_useState, 2),
    disableFollowingPages = _useState2[0],
    setDisableFollowingPages = _useState2[1];
  logPropError(errorProps, props, 'SteppedProgressBar');
  useEffect(function () {
    if (disableFollowingPageIndex !== undefined) {
      if (disableFollowingPageIndex < selectedStepNumber) {
        console.warn('Invalid component state detected in SteppedProgressBar: can not disable following ' + "pages ".concat(disableFollowingPageIndex, " when selectedStep is ").concat(selectedStepNumber, "!"));
        return;
      }
      setDisableFollowingPages(disableFollowingPageIndex);
    } else if (selectedStepNumber > disableFollowingPages) {
      setDisableFollowingPages(selectedStepNumber);
    }
  }, [disableFollowingPageIndex, selectedStepNumber]);
  var handleSelect = function handleSelect(selectedKey) {
    return onSelectedChanged(Number(selectedKey));
  };
  var wrapperClasses = classname('stepped-progress-bar', variant && "variant-".concat(variant), mobileBreakpoint && 'mobile-breakpoint', className && className);
  return /*#__PURE__*/React.createElement(Nav, {
    className: wrapperClasses,
    activeKey: selectedStepNumber,
    onSelect: handleSelect
  }, labels.map(function (labelObject, index) {
    return /*#__PURE__*/React.createElement(Nav.Link, {
      eventKey: index,
      disabled: index > disableFollowingPages,
      as: "a",
      key: index,
      className: classname('step-tab', labelObject.labelWrapperClassName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "step-tab-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "item-icon"
    }, labelObject.icon), /*#__PURE__*/React.createElement("div", {
      className: classname('item-label', labelObject.labelClassName)
    }, labelObject.label)));
  }));
};
SteppedProgressBar.VARIANT_CIRCLE = 'circle';
SteppedProgressBar.VARIANT_RECTANGLE = 'rectangle';
SteppedProgressBar.VARIANT_ROADSIGN = 'roadsign';
SteppedProgressBar.defaultProps = {
  selectedStepNumber: 1,
  labels: [],
  onSelectedChanged: function onSelectedChanged() {},
  variant: 'circle',
  mobileBreakpoint: true
};
SteppedProgressBar.propTypes = {
  disableFollowingPages: PropTypes.number,
  onSelectedChanged: PropTypes.func.isRequired,
  labels: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    labelClassName: PropTypes.string,
    labelWrapperClassName: PropTypes.string
  })).isRequired,
  itemClassName: PropTypes.string,
  selectedStepNumber: PropTypes.number.isRequired,
  className: PropTypes.string,
  mobileBreakpoint: PropTypes.bool,
  variant: PropTypes.oneOf([SteppedProgressBar.VARIANT_CIRCLE, SteppedProgressBar.VARIANT_RECTANGLE, SteppedProgressBar.VARIANT_ROADSIGN])
};
export default SteppedProgressBar;